let BASE_URL,VG_OSS_URL, QUOTE_BASE_URL, QUOTE_API_URL, OSS_URL, GC_PROD_URL, GC_PAY_URL, GC_ACCESS_URL, GC_LIVEROOM_URL, GC_CHATROOM_URL, GC_COURSE, ACCOUNT_TYPE,APP_ID = 1000;
// @ts-ignore
console.log('ENV', ENV)
const {NODE_ENV} = process.env;
let GS_TC_URL = 'http://gcts-wechat.beta.shrise.cn/';
let QT_WEB_HTTP_URL = 'https://q-api.shrise.cn';//行情web
let WS_URL = 'wss://im.shrise.cn/room/'
let WS_CHAT_URL = 'wss://im.shrise.cn/chat/'
let YOURUI_URL = 'https://quote.youruitech.com'
let MOCK_URL = 'https://m1.apifoxmock.com/m1/6943915-7179489-default';
let QUOTE_WS_URL = 'wss://quote-gateway.cf69.cn';
let DZ_BASE_URL = 'https://dz-quote.cf69.com';
let DZ_WS_URL = 'wss://dz-quote.cf69.com';



switch(ENV) {

  case 'beta':
    BASE_URL = 'https://api-web-beta.vgmarkets.com';
    QUOTE_BASE_URL = 'https://api-quote-v0.shrise.cn';
    QUOTE_API_URL = 'https://api-quote-beta.vgmarkets.com';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = "https://gc-access-betax.shrise.cn/"
    GC_PROD_URL = 'https://gc-prod-betax.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-betax.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-betax.shrise.cn/'
    GC_COURSE = 'https://gc-course-betax.shrise.cn/'
    WS_URL = 'wss://im-gateway-betax.shrise.cn/room/'
    QUOTE_WS_URL = 'wss://trade-gateway-beta.vgmarkets.com';
    VG_OSS_URL='https://vg-file-beta-oss.vgmarkets.com/'
    break;
  case 'betax':
    BASE_URL = 'https://api-web-betax.vgmarkets.com';
    QUOTE_BASE_URL = 'https://api-quote-v0.shrise.cn';
    QUOTE_API_URL = 'https://api-quote-beta.vgmarkets.com';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = "https://gc-access-betax.shrise.cn/"
    GC_PROD_URL = 'https://gc-prod-betax.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-betax.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-betax.shrise.cn/'
    GC_COURSE = 'https://gc-course-betax.shrise.cn/'
    WS_URL = 'wss://im-gateway-betax.shrise.cn/room/'
    QUOTE_WS_URL = 'wss://trade-gateway-beta.vgmarkets.com';
    VG_OSS_URL='https://vg-file-beta-oss.vgmarkets.com/'
    break;
  default:
    BASE_URL = ' https://api-web.vgmarkets.com';
    QUOTE_BASE_URL = 'https://api-quote.cf69.cn'
    QUOTE_API_URL = 'https://api-quote.vgmarkets.com';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GS_TC_URL = 'https://wxts.cf69.cn/'
    GC_ACCESS_URL = "https://gc-access.cf69.cn/"
    GC_PROD_URL = 'https://gc-prod.cf69.cn/';
    GC_PAY_URL = 'https://gc-pay.cf69.cn/';
    GC_LIVEROOM_URL = 'https://gc-liveroom.cf69.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom.cf69.cn/';
    GC_COURSE = 'https://gc-course.cf69.cn/';
    QUOTE_WS_URL = 'wss://trade-gateway.vgmarkets.com';
    APP_ID = 'wx0e69c06de17e6f83';
    ACCOUNT_TYPE = 40002;
    DZ_BASE_URL = 'https://dz-quote.cf69.com';
    DZ_WS_URL = 'wss://dz-quote.cf69.com';
    VG_OSS_URL='https://vg-file-oss.vgmarkets.com/'
}

const PRODUCT_TYPE = 192;
const COMPANY_TYPE = 45;
const WHITE_PAGE_LIST = ['/verification/slider-verification','/trading-guide','/user/login','mobile/user/login','/news/news-detail','/about-vg','/agreements/product-disclosure-statement','/agreements/risk-disclosure-statement','/agreements/privacy-policy','/agreements/customer-agreement','/announcement/announcement-detail','/agreements/withdrawal-disclaimer'];
if(NODE_ENV === 'development'){
  MOCK_URL = 'https://m1.apifoxmock.com/m1/6943915-6660313-default';
}

export default {
  VG_OSS_URL,
  MOCK_URL,
  ACCOUNT_TYPE,
  PRODUCT_TYPE,
  GC_PAY_URL,
  GS_TC_URL,
  GC_PROD_URL,
  BASE_URL,
  QUOTE_BASE_URL,
  QUOTE_API_URL,
  OSS_URL,
  QT_WEB_HTTP_URL,
  GC_ACCESS_URL,
  WHITE_PAGE_LIST,
  COMPANY_TYPE,
  GC_LIVEROOM_URL,
  GC_CHATROOM_URL,
  GC_COURSE,
  WS_URL,
  YOURUI_URL,
  WS_CHAT_URL,
  APP_ID,
  QUOTE_WS_URL,
  DZ_BASE_URL,
  DZ_WS_URL
}
